export const generatePluralNames = (names: string[], n: number): string =>
  n == 1 ? names[0] : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? names[1] : names[2];
